<template>
  <oil-form v-if="loading"
            :title="title.toUpperCase()"
            :createForm="!id"
            :keys="keys"
            :items="vehicle"
            :formCallback="formCallback"
  />
</template>

<script>
import keys from './setting/vehicle.json'
import {vehicleService} from "@/services/VehicleService"

export default {
  props: {
    id: String
  },
  data: () => ({
    keys: keys,
    loading: false,
    title: 'создать автомобиль',
    vehicle: {
      Name: '',
      Model: '',
      ModelRegistrationNumber: '',
      Status: 'active',
      IsOwn: true,
      Trailer1: '',
      Trailer1RegistrationNumber: '',
      Volume: '',
      StartDate: '',
      AdditionalInformation: '',
    }
  }),
  components: {
    OilForm: () => import('@/components/helper/oil.form')
  },
  async created() {
    if (this.id) {
      this.title = 'инфо о автомобиле'
      const vehicle = await vehicleService.getByIdOwner({id: this.id, isOwn: true})
      this.vehicle = vehicle.data
    }
    this.vehicle.IsOwn = true
    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? vehicleService.update : vehicleService.create
    }
  },
  methods: {
    async formCallback(data, input) {

      input.isEdit = false
      const vehicle = await this.storeType(data, true)
      const id = vehicle.data?.Id

      if (!id) {
        input.isEdit = true
        return
      }

      this.vehicle.Id = id
      this.vehicle = vehicle.data

      if (!this.id) {
        await this.$router.replace({
          path: `/vehicle/${this.vehicle.Id}`,
          replace: true
        })
        this.title = 'инфо о автомобиле'
      }

    }
  }

}
</script>